import React from 'react';
import ReactDOM from 'react-dom/client';
// Inter webfont — used only by the `.code-slashed-zero` utility so coded fields
// (ICD-10, subscriber/policy/group #, etc.) render 0 with a slash to distinguish
// it from the letter O. Roboto/system-sans have no slashed-zero glyph.
// NOTE: sourced from `inter-ui` (not `@fontsource/inter`) on purpose — the
// @fontsource subset strips the "zero" OpenType feature, so the slash never
// rendered. inter-ui's build keeps it (verified via fontTools GSUB inspection).
import 'inter-ui/inter-latin.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {Provider} from 'react-redux';
import {store} from './store/store';
import  ThemeContext  from "./jsx/context/ThemeContext"; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store = {store}>
    <BrowserRouter basename='/' future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ThemeContext>
        <App />
      </ThemeContext>
    </BrowserRouter>
  </Provider>
);
reportWebVitals();